import { useCallback } from 'react'
import { AccessDenied } from 'shared/errors/access-denied'
import { NotFound } from 'shared/errors/not-found'
import { UnprocessableContentError } from 'shared/errors/unprocessable-content-error'
import { useAcceptInvitation } from '../../api/accept-invitation'

interface AcceptInvitationParams {
  invitationToken: string
  confirmationToken?: string
}

interface UseAcceptInvitationFlowOptions {
  communityPath: string
}

export function useAcceptInvitationFlow({
  communityPath,
}: UseAcceptInvitationFlowOptions): (params: AcceptInvitationParams) => Promise<void> {
  const mutation = useAcceptInvitation({ communityPath })

  return useCallback(
    async function accept(params: AcceptInvitationParams): Promise<void> {
      const { invitationToken, confirmationToken } = params
      await mutation.mutateAsync(
        { invitationToken, confirmationToken },
        {
          onSuccess: () => {
            globalThis.location.replace(`/community/${communityPath}`)
          },
          onError: (error: Error) => {
            if (error instanceof AccessDenied) {
              globalThis.location.replace(
                `/community/${communityPath}?showInvalidInvitation=mismatch`,
              )
              return
            }
            if (error instanceof NotFound) {
              globalThis.location.replace(
                `/community/${communityPath}?showInvalidInvitation=canceled`,
              )
              return
            }
            if (error instanceof UnprocessableContentError) {
              globalThis.location.replace(
                `/community/${communityPath}?showInvalidInvitation=expired`,
              )
              return
            }
            throw error
          },
        },
      )
    },

    [mutation.mutateAsync, communityPath],
  )
}
